var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 100,
    viewBox: "0 0 500 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 10,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    transform: "rotate(10 10 20)"
  }, "%")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 20,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "white",
    transform: "rotate(10 90 40)"
  }, "%")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 25,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    transform: "rotate(10 170 60)"
  }, "%")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 30,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "white",
    transform: "rotate(10 250 80)"
  }, "%")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 40,
    fontFamily: "Arial",
    fontSize: 18,
    fill: "white",
    transform: "rotate(10 330 100)"
  }, "%")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 50,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "white",
    transform: "rotate(10 410 120)"
  }, "%")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 60,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    transform: "rotate(10 490 140)"
  }, "%")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 70,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "white",
    transform: "rotate(10 490 140)"
  }, "%")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 80,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    transform: "rotate(10 490 140)"
  }, "%")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.1d02d2db5a908187394a18ed72412f57.svg";
export { ForwardRef as ReactComponent };